import TeamNameMission from './team_name'
import OpenAnswerMission from './open_answer'
import SimpleTextMission from './simple_text'
import MultipleChoiceMission from './multiple_choice'
import ConnectDotsMission from './connect_dots'
import PhotoTimeMission from './photo_time'
import AudioMission from './audio_time'

type Props = {
  missionType: string;
}

const Missions = ({ missionType }: Props) => {
  switch (missionType) {
    case 'input_team': return <TeamNameMission />
    case 'input_text':
    case 'input_players': return <OpenAnswerMission />
    case 'simple_text': return <SimpleTextMission />
    case 'connections': return <ConnectDotsMission />
    case 'multiple_choice': return <MultipleChoiceMission />
    case 'input_total_players': return <MultipleChoiceMission />
    case 'picture': return <PhotoTimeMission />
    case 'audio': return <AudioMission />
    default: return <OpenAnswerMission />
  }
}

export default Missions
